import lightLogo from './assets/logo-light.png';
import darkLogo from './assets/logo-dark.png';
import lightIcon from './assets/icon-light.png';
import darkIcon from './assets/icon-dark.png';
import './brand.css';

export const getBrandNotificationIcon = () =>
  `${process.env.PUBLIC_URL || ''}/branding/icon-${
    typeof window !== 'undefined' &&
    window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  }.png`;

/** Header and other light surfaces use the light logo; dark surfaces opt in. */
export const BrandLogo = ({ surface = 'light', alt = 'ProTradesInsight', ...props }) => {
  return <img src={surface === 'dark' ? darkLogo : lightLogo} alt={alt} {...props} />;
};

export const BrandIcon = ({ surface = 'light', alt = 'ProTradesInsight icon', ...props }) => {
  return <img src={surface === 'dark' ? darkIcon : lightIcon} alt={alt} {...props} />;
};
